import { render, staticRenderFns } from "./BaseHeadline.vue?vue&type=template&id=158309d2"
import script from "./BaseHeadline.vue?vue&type=script&lang=ts"
export * from "./BaseHeadline.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports